import { render, staticRenderFns } from "./materialsLink.vue?vue&type=template&id=efc3c718&scoped=true"
import script from "./materialsLink.vue?vue&type=script&lang=js"
export * from "./materialsLink.vue?vue&type=script&lang=js"
import style0 from "./materialsLink.vue?vue&type=style&index=0&id=efc3c718&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efc3c718",
  null
  
)

export default component.exports